
import React, { useState } from 'react';

import { ReactComponent as SearchIcon } from '../../assets/icons/search-icon.svg';

// Filtro: testo + date-range
const FaqFilterBar = ({ filterParams, onChange }) => {
    const { titolo } = filterParams;
    return (
        <div className="vista-filter-bar">
            <div className="search-wrapper">
                <SearchIcon className="search-icon" />
                <input
                    type="text"
                    className="search"
                    name="titolo"
                    placeholder="Ricerca per titolo"
                    value={titolo}
                    onChange={e => onChange({ ...filterParams, titolo: e.target.value })}
                />
            </div>
        </div>
    );
}
export default FaqFilterBar;